// removed by extract-text-webpack-plugin
module.exports = {"progress":"_11cmnqpRt-sXG04g4-EwxF","spin":"_28tiEbZQEoEsqahq-_Gzn_"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Loading/style.css
// module id = 211
// module chunks = 101